// extracted by mini-css-extract-plugin
export var discard = "_2m-3";
export var muiTooltipTooltip = "_2m-5";
export var notificationBar = "_2m-2";
export var saveButtonHoverSlotWrapper = "_2m-4";
export var show = "_2m-1";
export var spacer = "_2m-0";